// FORMAT POSTAL CODE INPUT
const formatServicePostalCode = function (postalCodeInput) {
    let timer;

    const formatInput = function (postalCodeInput) {
        let $this = $(postalCodeInput);
        let $inputParent = $this.parent();
        let $inputSubmitBtn = $inputParent.parent().find('.postalCode_submit');

        $this.mask('S0S 0S0');

        $this.on('keyup focus', function () {
            timer = setTimeout(validatePostalCode(this.value, $inputSubmitBtn), 500);
        });
    }

    function validatePostalCode(value, $inputSubmitBtn) {
        let postalLength = value.length;
        if (postalLength === 0) {
            $inputSubmitBtn.prop('disabled', true);
        } else if (postalLength === 7) {
            $inputSubmitBtn.prop('disabled', false);
        } else if (postalLength < 7 && postalLength > 0) {
            $inputSubmitBtn.prop('disabled', true);
        }

        clearTimeout(timer);
    }

    return {
        formatInput: formatInput
    }
}();

const sidePanelControl = function () {
    let pannelIsOpen = true;

    const closeStoreToggle = function () {
        $('.pickupStoreSelection').removeClass('active');
        $('#timeslotStoreSelect').attr('aria-expanded', false);
        $('.pickupStoreSelection .accordion--text').hide();
    };

    const storeSelectToggle = function () {
        let $toggleStoreSelect = $('#timeslotStoreSelect');
        let $container = $(".pickupStoreSelection");
        let toggleStoreSelectActive;
        let clickedElm;
        let clickBool;

        $($toggleStoreSelect).on('click', function () {
            $(document).mouseup(function (e) {
                toggleStoreSelectActive = $toggleStoreSelect.attr('aria-expanded');

                if (toggleStoreSelectActive === 'true') {
                    clickedElm = e.target;
                    clickBool = $container.find(clickedElm).length;
                    if (!clickBool) {
                        closeStoreToggle();
                    }
                }
            });
        });
    };

    const remodalCloseEvent = function () {
        let $serviceTimeslotContainer = $('[data-remodal-id=serviceTimeSlotPanel]');
        if ($serviceTimeslotContainer.length) {
            let inst;
            let remodalElm = document.querySelector('.st_panel');

            var observer = new MutationObserver(function (mutations) {
                inst = $.remodal.lookup[$serviceTimeslotContainer.data('remodal')];

                if (inst.state === 'opened') {
                    ServiceTimeslot.bindCloseButton();
                }

                if (inst.state === 'closing') {
                    // On close servicetimeslot event
                    ServiceTimeslot.onCloseModalServiceAndTimeslot();
                    pannelIsOpen = true;
                }
            });

            observer.observe(remodalElm, {
                attributes: true,
                childList: false,
                characterData: false
            });
        }
    };

    const submitActivation = function () {
        let checkedService = ServiceTimeslot.getToggleServiceType();
        let storeSelected = $('.pickup-store-select input[name=pickUpStoreSelect]:checked').length;
        if ((checkedService !== ServiceTimeslot.SERVICE_TYPE_ECOMM_DELIVERY && !storeSelected) || typeof checkedService === 'undefined') {
            disableConfirmTimeslotButton(true);
        } else {
            disableConfirmTimeslotButton(false);
        }
    }

    function disableConfirmTimeslotButton(disable) {
        $('#confirmTimeslot').prop('disabled', disable);
    }

    return {
        storeSelectToggle: storeSelectToggle,
        closeStoreToggle: closeStoreToggle,
        remodalCloseEvent: remodalCloseEvent,
        submitActivation: submitActivation,
        disableConfirmTimeslotButton: disableConfirmTimeslotButton
    }
}();

const toggleServiceAction = function (checkedService) {
    if (checkedService === ServiceTimeslot.SERVICE_TYPE_ECOMM_DELIVERY) {
        $('.footerDelivery').show();
        $('.footerPickup').hide();
        $('.delivery-service--content').show();
        $('.pickup-service--content').hide();
        $('.select--pickup-service').hide();
    } else if (checkedService === ServiceTimeslot.SERVICE_TYPE_ECOMM_PICKUP) {
        $('.footerDelivery').hide();
        $('.footerPickup').show();
        $('.delivery-service--content').hide();
        $('.pickup-service--content').show();
        $('.select--pickup-service').show();
        ServiceTimeslot.manageFooterStoreSelect();
    } else {
        $('.footerDelivery').hide();
        $('.footerPickup').hide();
        $('.delivery-service--content').hide();
        $('.pickup-service--content').hide();
        $('.select--pickup-service').hide();
    }
};

const toggleServiceBtn = function () {
    let $serviceCheckbox = $('.st__serviceType input[name="radioServiceType"]');
    let checkedService = ServiceTimeslot.getToggleServiceType();

    $serviceCheckbox.on('change', function () {
        checkedService = ServiceTimeslot.getToggleServiceType();
        toggleServiceAction(checkedService);
        closePickUpToolTip();
        sidePanelControl.submitActivation();
    });
    toggleServiceAction(checkedService);
};

const closePickUpToolTip = function () {
    $('.store-tool-tip').attr('aria-expanded', false);
    $('.store-tool-tip-content').addClass('hide');
}

const pickUpToolTip = function () {
    $('.store-tool-tip').on('click', function() {
       let $this = $(this);
       let toolTipState = $this.attr('aria-expanded');
       if (toolTipState === 'false') {
           closePickUpToolTip();
           $this.attr('aria-expanded', true);
           $this.next('.store-tool-tip-content').removeClass('hide');
           $this.next('.store-tool-tip-content').find('.close-tool-tip').focus();
           $this.next('.store-tool-tip-content')[0].scrollIntoView({block: "end"});
       } else {
           closePickUpToolTip();
       }
    });

    $('.close-tool-tip').on('click', function () {
        closePickUpToolTip();
    });
}

// OPEN SERVICE TIMESLOT PANEL FUNCTION
const $remodal = $('div[data-remodal-id="serviceTimeSlotPanel"]');
const openServiceTimeslot = function () {
    $remodal.addClass('in-progress');
    $remodal.remodal().open();
    if ($remodal.state === 'closed') {
        $remodal.remodal().open();
    }
};

const closeServiceTimeslot = function () {
    $remodal.remodal().close();
};

const initServiceTimeslot = function () {
    let $inputPostalCode = $('#deliveryPostalCode');
    $('.pickup-store-select').accordion_default();
    showOverlayServiceBox.removeOverlayServiceBox();
    formatServicePostalCode.formatInput($inputPostalCode);
    sidePanelControl.storeSelectToggle();
    toggleServiceBtn();
    sidePanelControl.submitActivation();
    pickUpToolTip();
    $remodal.removeClass('in-progress');
    $('#modal-service-and-timeslot').removeClass('in-progress');
    let availableService = $('.st__serviceType.activeFields');
    if (availableService.length) {
        availableService.find('input:checked + label').focus();
    }
};